import React from "react";

function Spacer(props) {
    return (<div style={{ width: '100%', height: props.verticalSize + 'px' }}></div>);
}

export default Spacer;